import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { entries } from 'mobx';
import get from "lodash/get.js";
import { coerceToNumber } from "../utils.js";
export class ApiLocationResolver {
  constructor() {
    _defineProperty(this, "_propertyResolvers", void 0);
    _defineProperty(this, "_nameResolver", null);
    _defineProperty(this, "_idResolver", null);
    _defineProperty(this, "_latLngResolver", null);
    this._propertyResolvers = {};
    this._nameResolver = null;
    this._idResolver = null;
    this._latLngResolver = null;
  }
  resolveName(resolver) {
    if (typeof resolver === 'string') {
      this._nameResolver = rawResult => get(rawResult, resolver);
    } else {
      this._nameResolver = resolver;
    }
    return this;
  }
  resolveId(resolver) {
    if (typeof resolver === 'string') {
      this._idResolver = rawResult => String(get(rawResult, resolver));
    } else {
      this._idResolver = resolver;
    }
    return this;
  }
  resolveLatLng(resolver) {
    if (typeof resolver === 'object' && typeof resolver.lat === 'string' && typeof resolver.lng === 'string') {
      this._latLngResolver = rawResult => ({
        lat: coerceToNumber(get(rawResult, resolver.lat)),
        lng: coerceToNumber(get(rawResult, resolver.lng))
      });
    } else {
      this._latLngResolver = resolver;
    }
    return this;
  }
  resolve(key, resolver) {
    if (!resolver) {
      this._propertyResolvers[key] = rawResult => get(rawResult, key);
    } else if (typeof resolver === 'string') {
      this._propertyResolvers[key] = rawResult => get(rawResult, resolver);
    } else {
      this._propertyResolvers[key] = resolver;
    }
    return this;
  }
  mapResult(rawResult, rawResponse) {
    // very fragile, there should be be some (light) runtime typechecking
    if (!this._idResolver) throw new Error('no id resolver');
    if (!this._nameResolver) throw new Error('no name resolver');
    if (!this._latLngResolver) throw new Error('no lat/lng resolver');
    var result = _objectSpread(_objectSpread({
      id: this._idResolver(rawResult, rawResponse),
      locationName: this._nameResolver(rawResult, rawResponse)
    }, this._latLngResolver(rawResult, rawResponse)), {}, {
      fields: Object.keys(this._propertyResolvers).reduce((r, k) => _objectSpread(_objectSpread({}, r), {}, {
        [k]: this._propertyResolvers[k](rawResult, rawResponse)
      }), {}),
      data: rawResult
    });
    return result;
  }
}
export class ApiAdapter {
  constructor() {
    _defineProperty(this, "_mergeHandler", void 0);
    _defineProperty(this, "_requestHandler", void 0);
    _defineProperty(this, "_resultsResolver", void 0);
    _defineProperty(this, "_coordCollisionMap", void 0);
    _defineProperty(this, "location", void 0);
    this.location = new ApiLocationResolver();
    this.handleMerge('replace');
  }
  resolveResults(resolver) {
    if (typeof resolver === 'string') {
      this._resultsResolver = rawResult => get(rawResult, resolver);
    } else {
      this._resultsResolver = resolver;
    }
    return this;
  }
  handleMerge(handler) {
    if (typeof handler === 'string') {
      this._mergeHandler = (results, store) => store.setResults(results, handler);
    } else {
      this._mergeHandler = handler;
    }
    return this;
  }
  extractResults(response) {
    var rawResults = this._resultsResolver(response);
    return rawResults.map(result => this.location.mapResult(result, response));
  }
  handleRequest(handler) {
    this._requestHandler = handler;
    return this;
  }
  fetchResults(store) {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (!_this._requestHandler) throw new Error('no request handler defined');
      var filterValueMap = {};
      for (var [propName, value] of entries(store.filterMap)) {
        filterValueMap[propName] = value;
      }
      var rawResponse = yield _this._requestHandler(filterValueMap, store);
      var results = _this.extractResults(rawResponse);
      _this._mergeHandler(results, store);
      store.endFetch();
      return results;
    })();
  }
}
export default ApiAdapter;
//# sourceMappingURL=ApiAdapter.js.map